import React from 'react'
import {AiOutlineCaretDown , AiFillShopping , AiFillCaretRight } from "react-icons/ai"
import {GiMedicines} from "react-icons/gi"
import Cotisation from '../clients/Cotisation'
import AddClient from './AddClient'
import AddHospital from './AddHospital'
import AddPharmacie from './AddPharmacie'
import CommandesList from './CommandesList'
import ListClients from './ListClients'
import ListCotisation from './ListCotisation'
import ListHospitals from './ListHospitals'
import ListPharmacies from './ListPharmacies'
export  const dashbordAdmin = [
    {
        title: 'Commandes',
        cName : "clientMedicament",
        titleIcon: <AiFillCaretRight />,
        content: [{
                icon: <GiMedicines /> ,
                contentText : "Toutes",
                path:'listAllCommandes',
                destination: <CommandesList isValid={null} isArchived={false}/>
            },
            {
                icon: <AiFillShopping />,
                contentText : "En cours",
                path:'listCurrentCommandes',
                destination: <CommandesList isValid={false} isArchived={false}/>
            },
            {
                icon: <AiFillShopping />,
                contentText : "Deja validées",
                path:'listValidesCommandes',
                destination: <CommandesList isValid={true} isArchived={false}/>
            },
            {
                icon: <AiFillShopping />,
                contentText : "Archive",
                path:'listArchivedCommandes',
                destination: <CommandesList isValid={null} isArchived={true}/>
            }
        ]
    },
    {
        title: 'Pharmacie',
        cName : "clientPharmacie",
        titleIcon: <AiFillCaretRight />,
        content: [{
                icon: <GiMedicines /> ,
                contentText : "Ajouter une pharmacie",
                path:'addPharmacie',
                destination: <AddPharmacie/>
            },
            {
                icon: <AiFillShopping />,
                contentText : "voir nos pharmacies",
                path:'listPharmacies',
                destination: <ListPharmacies isArchived={false}/>
            },
            {
                icon: <AiFillShopping />,
                contentText : "Archive",
                path:'listPharmaciesArchived',
                destination: <ListPharmacies isArchived={true}/>
            }
        ]
    },
    {
        title: 'Postes de santé',
        cName : "clientHospital",
        titleIcon: <AiFillCaretRight />,
        content: [{
                icon: <GiMedicines /> ,
                contentText : "Ajouter une poste de santé",
                path:'addHospital',
                destination: <AddHospital isArchived={true}/>
            },
            {
                icon: <AiFillShopping />,
                contentText : "Liste des postes de santé",
                path:'listHospitals',
                destination: <ListHospitals isArchived={false}/>
            },
            {
                icon: <AiFillShopping />,
                contentText : "Archive",
                path:'listArchivedHospitals',
                destination: <ListHospitals isArchived={true}/>
            }
        ]
    },
    {
        title: 'Clients',
        cName : "clients",
        titleIcon: <AiFillCaretRight />,
        content: [{
                icon: <GiMedicines /> ,
                contentText : "Ajouter un nouveau client",
                path:'addClient',
                destination: <AddClient isArchived={true}/>
            },
            {
                icon: <AiFillShopping />,
                contentText : "Liste de nos clients",
                path:'listClients',
                destination: <ListClients isArchived={false}/>
            },
            {
                icon: <AiFillShopping />,
                contentText : "Archive",
                path:'archivedClients',
                destination: <ListClients isArchived={true}/>
            }
        ]
    },
    {
        title: 'Cotisation',
        cName : "cotisation",
        titleIcon: <AiFillCaretRight />,
        content: [{
                icon: <GiMedicines /> ,
                contentText : "Liste des cotisation",
                path:'cotisation',
                destination: <ListCotisation/>
            }
        ]
    }
]
